import {
  PurchaseReportsInitialState,
  PurchaseReportsRequestParams
} from "src/pages/PurchaseRegister/interface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getVendorList, getPurchaseReportsData } from "src/api/sp";
import { resetStore } from "src/store/actions";
import { API_STATUS } from "src/config/constants/genericConstants";
import { formatPurchaseRegisterDetails } from "./Utils";

export const fetchPurchaseReportsData = createAsyncThunk(
  "reports/fetchPurchaseReportsData",
  (payload: PurchaseReportsRequestParams) => getPurchaseReportsData(payload)
);

export const fetchVendorList = createAsyncThunk(
  "reports/fetchVendorList",
  (payload: {
    DateFrom: string;
    DateTo: string;
    storeId: string;
    signal?: AbortSignal | null;
  }) => getVendorList(payload)
);

const initialState: PurchaseReportsInitialState = {
  status: API_STATUS.IDLE,
  data: {
    purchaseRegisterDetails: [],
    stats: {
      apCost: "",
      storeCost: ""
    }
  },
  error: null,
  recordsCount: null,
  vendorList: [],
  vendorListStatus: API_STATUS.IDLE
};

const viewPurchaseReportsTableDataSlice = createSlice({
  name: "purchaseReports",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchPurchaseReportsData.pending, (state) => {
        state.status = API_STATUS.PENDING;
      })
      .addCase(fetchPurchaseReportsData.fulfilled, (state, { payload }) => {
        if (payload?.data) {
          const { purchaseRegisterDetails, consolidatedStats } = payload.data;
          state.data.stats = consolidatedStats;
          state.data.purchaseRegisterDetails = formatPurchaseRegisterDetails(
            purchaseRegisterDetails
          );
          state.recordsCount = payload?.recordsCount;
        }
        state.status = API_STATUS.IDLE;
      })
      .addCase(fetchPurchaseReportsData.rejected, (state) => {
        state.status = API_STATUS.ERROR;
      })
      .addCase(fetchVendorList.pending, (state) => {
        state.vendorListStatus = API_STATUS.PENDING;
      })
      .addCase(fetchVendorList.fulfilled, (state, { payload }) => {
        state.vendorListStatus = API_STATUS.IDLE;
        state.vendorList = payload?.data.map(
          (option: { vendorId: string; vendorName: string }) => ({
            id: option.vendorId,
            name: option.vendorName
          })
        );
      })
      .addCase(fetchVendorList.rejected, (state) => {
        state.vendorListStatus = API_STATUS.ERROR;
      });
  }
});

export default viewPurchaseReportsTableDataSlice.reducer;
